
import { defineComponent, ref, onMounted, computed } from "vue";
import KTMenu from "@/layout/header/Menu.vue";
import KTMenuDropdown from "@/layout/header/MenuDropdown.vue";
import { useStore } from "vuex";
import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "KTHeader",
  props: {
    user: Boolean
  },
  components: {
    KTMenu,
    KTMenuDropdown,
  },
  setup() {
    const store = useStore();
    const isMobile = ref(false);
    const route = useRoute();
    
    onMounted( () => {
      let userAgent = navigator.userAgent || navigator.vendor;
      if(userAgent.match( /Android/i) || userAgent.match(/iPhone/i)) {
        isMobile.value = true;
      } else {
        isMobile.value = false;
      }
    });
    return {
      headerTitle: computed(() => store.getters.concessionariaSelectedInfo?.nomeFantasia),
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      isMobile,
      route
    };
  },
});
